module.exports = __webpack_public_path__ + "catalog/items/firesafety/ControlPanel/ControlPanel.svg";